import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';

// A section as one row: its heading and a one-line summary (green or a
// soft red); a click opens it to show the details, another closes it.
// forceOpen: shown open whatever was clicked (printing).
const CollapsibleRow = ({ title, summary = null, tone = '', defaultOpen = false, forceOpen = false, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  const shown = open || forceOpen;
  return (
    <section className="border-b border-gray-200 dark:border-slate-700">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={shown}
        className="w-full flex items-center gap-2 px-1 py-2.5 text-left hover:bg-gray-50 dark:hover:bg-slate-800/60 focus:outline-none focus-visible:bg-gray-50"
      >
        <ChevronRight size={14} aria-hidden="true" className={`shrink-0 text-gray-400 transition-transform ${shown ? 'rotate-90' : ''}`} />
        <span className="flex-1 min-w-0 text-xs font-semibold uppercase tracking-wide text-gray-700 dark:text-slate-200">{title}</span>
        {summary && <span className={`shrink-0 text-right text-xs font-medium ${tone || 'text-gray-600 dark:text-slate-300'}`}>{summary}</span>}
      </button>
      {shown && <div className="px-1 pt-1 pb-4">{children}</div>}
    </section>
  );
};

export default CollapsibleRow;
